import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Button } from '@tis/shared-tis-ui';
import React from 'react';
import styles from '../Dialog.module.scss';

interface ErrorDialogProps {
  message: string;
  onClose: () => void;
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ message, onClose }) => {
  return (
    <>
      <DialogTitle className={styles.errorHeader}>Error</DialogTitle>
      <DialogContent className={styles.dialogContent}>{message}</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </>
  );
};

export default ErrorDialog;
